<template lang="pug">
.v-field-table-sort.field-table-sort(:class="computedClass")
	.field-table-sort__list
		template(v-for="(option, index) in field.options" :key="index")
			.field-table-sort__item(:class="computedClassOptions?.[index]")
				button.field-table-sort__button(@click="localValue = option.value; handleInput();" :class="{'field-table-sort__button--active' : localValue === option.value}")
					.field-table-sort__button-text {{option.text}}
					v-svg-icon.field-table-sort__button-icon(icon="arrow-sort")

</template>

<script>
	export default  {
		emits: [
			'update:model-value',
		],
		props: {
			field: {
				type:Object,
				default: null
			},
			modelValue: {
				type: [Object, String, Number, Boolean, Symbol, Date],
				default: null
			},
		},

		data() {
			return {
				localValue: null
			}
		},
		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},
			handleInput() {
				this.$emit('update:model-value', this.localValue);
				this.updateLocalValue()
			}
		},
		computed: {
			computedClass() {
				return [
					'field-toggle--' + (this.field?.size || 'l'),
				];
			},
			computedClassOptions() {
				return this.field?.optionsClassNames?.reduce((acc, cur, index) => {
					acc[index] = cur;
					return acc
				}, {});
			}
		},
		watch: {
			modelValue: {
				immediate: true,
				handler() {
					this.updateLocalValue();
				}
			}
		}
	}
</script>